import { Box } from '@mui/material';
import { useState } from 'react';
import useFetchApiData from '../../../core/hooks/useFetchApiData';
import Layout from '../../../core/ui/layout/Layout';
import TableContainer from '../../../core/ui/table/TableContainer';
import { TableHeader } from '../../../core/ui/table/tableTypes';
import { Paginated } from '../../../core/utils/types';
import { parseQuery } from '../../../core/utils/utility';
import { Newsletter } from '../newsletter';
import { useSendApiData } from '../../../core/hooks/useSendApiData';
import { toastError, toastMessage } from '../../../core/utils/ui/alert';

const tableHeaders: TableHeader[] = [
  { field: 'title', label: 'Title', align: 'left' },
  // { field: 'content', label: 'Content', align: 'left' },
];
const NewsletterList = () => {
  const [data, setData] = useState<Record<string, any>[]>([]);
  const { fetchData } = useFetchApiData();
  const { callApi } = useSendApiData();

  const handleFetchData = async (query: any, cb: (c: number) => void) => {
    await fetchData(`newsletters${parseQuery(query)}`, {
      onSuccess: ({ total, data: apiData }: Paginated<Newsletter>) => {
        setData(apiData);
        cb(total);
      },
    });
  };

  const handleDelete = async (id: number | string, showMessage = true) => {
    let success = false;

    await callApi({
      endpoint: `auth-ea35a/newsletters/${id}`,
      data: {},
      method: 'delete',
      onSuccess: async () => {
        if (showMessage) toastMessage('Newsletter Removed');
        success = true;
      },
      onError: () => {
        if (showMessage)
          toastError('Something went wrong while deleting. Try again');
      },
    });

    return success;
  };

  return (
    <>
      <Layout>
        <Box sx={{ p: 2 }}>
          <TableContainer
            modelToken="newsletter"
            tableHeaders={tableHeaders}
            data={data}
            modelLabel="Newsletters"
            addRoute="/newsletters/create"
            editRoutePrefix="/newsletters/edit"
            actions={{
              onFetchData: handleFetchData,
              onDelete: handleDelete,
            }}
            fieldMap={{
              title: 'string',
              content: 'string',
            }}
            settings={{
              canCreate: true,
              canEdit: true,
              canDelete: true,
            }}
          />
        </Box>
      </Layout>
    </>
  );
};

export default NewsletterList;
